module.exports = __webpack_public_path__ + "static/media/financial-worries-large@2x.167cce23.png";